export const GALLERY_MOBILE_MAX_WIDTH = 767;
export const GALLERY_MOBILE_MEDIA_QUERY = `(max-width: ${GALLERY_MOBILE_MAX_WIDTH}px)`;

export const getGalleryMediaFrame = ({
  mediaRect,
  overlayRect,
  stageRect,
  isMobileViewport,
  isMobileMediaZoomed,
  isMobilePhoto,
  pageZoom = 1,
}) => {
  const rect =
    isMobileViewport && isMobileMediaZoomed && !isMobilePhoto
      ? stageRect || mediaRect
      : mediaRect;

  return {
    rect,
    style: {
      left: `${(rect.left - overlayRect.left) / pageZoom}px`,
      top: `${(rect.top - overlayRect.top) / pageZoom}px`,
      width: `${rect.width / pageZoom}px`,
      height: `${rect.height / pageZoom}px`,
    },
  };
};

// As ações cabem na parte visível da imagem; a legenda usa o quadro completo.
export const getGalleryMediaActionStyle = ({
  mediaRect,
  stageRect,
  pageZoom = 1,
}) => {
  const left = Math.max(mediaRect.left, stageRect.left);
  const right = Math.min(
    mediaRect.left + mediaRect.width,
    stageRect.left + stageRect.width
  );

  return {
    width: `${Math.max(0, right - left) / pageZoom}px`,
    marginLeft: `${(left - mediaRect.left) / pageZoom}px`,
  };
};

export const getGalleryCaptionPlacement = ({
  hasCaption,
  isMobileViewport,
  hasExtendedMediaActions,
  isInstagramQuestionVideo,
  isImage,
  isVideo = false,
  isGifMedia,
  isSticker,
  isImageZoomed,
}) => {
  if (!hasCaption) return 'hidden';

  const isMobilePhoto =
    isMobileViewport && isImage && !isGifMedia && !isSticker;

  if (isImageZoomed) return isMobilePhoto ? 'overlay' : 'hidden';
  if (isMobilePhoto) {
    return 'mobile-flow';
  }
  if (
    isMobileViewport &&
    hasExtendedMediaActions &&
    !isInstagramQuestionVideo &&
    !isVideo
  ) {
    return 'overlay';
  }
  return 'flow';
};
